// @flow

import React, { Component } from 'react';

type Props = {
  color: string,
  down: boolean,
  inverted: boolean,
  up: boolean
};

class Arrow extends Component<Props> {

  static defaultProps = {
    color: '#EFF0F1',
    down: false,
    inverted: false,
    up: true
  }

  renderPath = () => {
    if (this.props.down) {
      return <path d="M 0 0 L 375 0 L 187 23 L 0 0" fill={this.props.color} />;
    }
    else if (this.props.inverted) {
      return <path d="M 0 0 L 187 23 L 375 0 L 375 23 L 0 23 L 0 0" fill={this.props.color} />;
    }
    return <path d="M 0 23 L 187 0 L 375 23 L 0 23" fill={this.props.color} />;
  }

  getClassName() {
    let arrowClass = 'up';
    if (this.props.down) {
      arrowClass = 'down';
    }
    else if (this.props.inverted) {
      arrowClass = 'inverted';
    }
    return `arrow arrow-${arrowClass}`;
  }

  render() {
    return (
      <svg
        className={this.getClassName()}
        width="100%"
        height="23.5"
        viewBox="0 0 375 23"
        preserveAspectRatio="none"
        style={{ display: 'block' }}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink">
        {this.renderPath()}
      </svg>
    );
  }

}

export default Arrow;



// WEBPACK FOOTER //
// ./src/components/Arrow.js